<template>
  <div class="form-container">
    <!-- 电脑端使用 Element UI 表单 -->
    <section v-if="isDesktop" style="padding:0 5%;">
      <el-form
        ref="form"
        label-position="top"
        status-icon
        :model="form"
        :rules="rules"
        label-width="100px"
        style="width:100%;"
      >
        <el-form-item label="账号" prop="username" required>
          <el-input v-model="form.username" placeholder="请输入手机号做为登录账号" disabled></el-input>
        </el-form-item>
        <el-form-item label="真实姓名" prop="nickname" required>
          <el-input v-model="form.nickname" placeholder="请输入真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" required>
          <el-radio v-model="form.gender" :label="0">男</el-radio>
          <el-radio v-model="form.gender" :label="1">女</el-radio>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>

        <el-form-item label="角色" prop="role">
          <el-select multiple v-model="form.role" placeholder="请选择需要绑定角色">
            <el-option
              v-for="(value,key) in roles"
              :key="key"
              :label="value.role_name"
              :value="value.role_id">
              <span style="float: left">{{ value.role_name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{ value.role_id }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="标签" prop="tags">
          <el-select multiple v-model="form.tags" placeholder="请选择需要绑定标签">
            <el-option
              v-for="(value,key) in tags"
              :key="key"
              :label="value.name"
              :value="value.tag_id">
              <span style="float: left">{{ value.name }}</span>
              <span style="float: right; font-size: 13px" :style="{'color':value.color}">{{ value.tag_id }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="公司" prop="group_id" v-if="group_id === 1">
          <el-select v-model="form.group_id" placeholder="请选择任职公司" disabled>
            <el-option
              v-for="(value,key) in groups"
              :key="key"
              :label="value.name"
              :value="value.id">
              <span style="float: left">{{ value.name }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button @click="close('form')">取消</el-button>
          <el-button type="primary" @click="submit('form')" :plain="true">立即修改</el-button>
        </el-form-item>
      </el-form>
    </section>

    <!-- 手机端使用 Vant 表单 -->
    <div v-else class="mobile-form-container">
      <div class="mobile-form-content">
        <van-form ref="mobileForm" :model="form" :rules="rules" @submit="onMobileSubmit">
          <!-- 账号 -->
          <van-cell-group inset>
            <van-field
              v-model="form.username"
              name="username"
              label="账号"
              input-align="right"
              placeholder="请输入手机号做为登录账号"
              disabled
              readonly
            />
            
            <!-- 真实姓名 -->
            <van-field
              v-model="form.nickname"
              name="nickname"
              label="真实姓名"
              input-align="right"
              placeholder="请输入真实姓名"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 性别 -->
            <van-cell title="性别" is-link @click="showGenderPicker = true">
              <template #right-icon>
                <span>{{ form.gender === 0 ? '男' : '女' }}</span>
              </template>
            </van-cell>
            
            <!-- Email -->
            <van-field
              v-model="form.email"
              name="email"
              label="Email"
              input-align="right"
              placeholder="请输入邮箱"
              :rules="[{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'onBlur' }]"
              :validate-trigger="['onChange', 'onBlur']"
            />
            
            <!-- 角色 -->
            <van-cell title="角色" is-link @click="showRolePicker = true">
              <template #right-icon>
                <span>{{ selectedRolesText }}</span>
              </template>
            </van-cell>
            
            <!-- 标签 -->
            <van-cell title="标签" is-link @click="showTagPicker = true">
              <template #right-icon>
                <span>{{ selectedTagsText }}</span>
              </template>
            </van-cell>
            
            <!-- 公司 -->
            <van-cell v-if="group_id === 1" title="公司" disabled>
              <template #right-icon>
                <span>{{ selectedGroupText }}</span>
              </template>
            </van-cell>
          </van-cell-group>
          
          <!-- 性别选择器 -->
          <van-popup v-model="showGenderPicker" position="bottom" :round="true">
            <van-picker
              show-toolbar
              :columns="genderColumns"
              @confirm="onGenderConfirm"
              @cancel="showGenderPicker = false"
            />
          </van-popup>
          
          <!-- 角色选择器 -->
          <van-popup v-model="showRolePicker" position="bottom" :round="true" :style="{ height: '50%' }">
            <van-picker
              show-toolbar
              :columns="roleColumns"
              @confirm="onRoleConfirm"
              @cancel="showRolePicker = false"
              multiple
            />
          </van-popup>
          
          <!-- 标签选择器 -->
          <van-popup v-model="showTagPicker" position="bottom" :round="true" :style="{ height: '50%' }">
            <van-picker
              show-toolbar
              :columns="tagColumns"
              @confirm="onTagConfirm"
              @cancel="showTagPicker = false"
              multiple
            />
          </van-popup>
        </van-form>
      </div>
      
      <!-- 手机端固定底部按钮 -->
      <div class="mobile-form-actions">
        <van-button type="default" block @click="close">取消</van-button>
        <van-button type="primary" block @click="onMobileSubmit">立即修改</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  let _this;
  import {getRoles,getTags,updateAdmin,getGroups,getAdmin} from "@/api/system.js";
  import { Field, Cell, CellGroup, Popup, Picker, Form, Button, Toast } from 'vant';
  
  export default {
    props: {
      id: Number
    },
    components: {
      [Field.name]: Field,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Popup.name]: Popup,
      [Picker.name]: Picker,
      [Form.name]: Form,
      [Button.name]: Button
    },
    data() {
      return {
        isDesktop: true,
        form: {
          username: "",
          nickname: "",
          gender: 0,
          email:'',
          avatar:'',
          role:[],
          tags:[],
          group_id:'',
          department_id:''
        },

        group_id:'',
        tags:[],
        roles:[],
        groups:[],
        
        // 手机端选择器
        showGenderPicker: false,
        showRolePicker: false,
        showTagPicker: false,
        
        // 选择器列数据
        genderColumns: ['男', '女'],
        roleColumns: [],
        tagColumns: [],

        rules: {
          username: [
            {required: true, message: "请输入手机号做为登录账号", trigger: "blur"},
          ],
          nickname: [
            {required: true, message: "请输入昵称", trigger: "change"},
          ],
        },
        
      };
    },

    computed: {
      // 角色选择文本
      selectedRolesText() {
        if (!this.form.role || this.form.role.length === 0) {
          return '请选择角色';
        }
        const selectedRoles = this.roles.filter(role => this.form.role.includes(role.role_id));
        return selectedRoles.map(role => role.role_name).join(', ');
      },
      
      // 标签选择文本
      selectedTagsText() {
        if (!this.form.tags || this.form.tags.length === 0) {
          return '请选择标签';
        }
        const selectedTags = this.tags.filter(tag => this.form.tags.includes(tag.tag_id));
        return selectedTags.map(tag => tag.name).join(', ');
      },
      
      // 公司选择文本
      selectedGroupText() {
        if (!this.form.group_id) {
          return '';
        }
        const selectedGroup = this.groups.find(group => group.id === this.form.group_id);
        return selectedGroup ? selectedGroup.name : '';
      }
    },

    mounted() {
      _this = this;
      _this.init();
      this.checkScreenSize();
      window.addEventListener('resize', this.handleResize);
      this.group_id = this.$store.state.user.userData.group_id
    },
    
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    },

    methods: {
      // 检查屏幕大小
      checkScreenSize() {
        this.isDesktop = window.innerWidth > 768;
      },
      
      // 处理窗口大小变化
      handleResize() {
        this.checkScreenSize();
      },
      
      // 初始化数据
      init() {
        getRoles().then(res=>{
          if(res.code === 200){
            this.roles = res.data;
            // 初始化角色选择器列
            this.roleColumns = this.roles.map(role => role.role_name);
          }
        })
        getTags().then(res=>{
          if(res.code === 200){
            this.tags = res.data;
            // 初始化标签选择器列
            this.tagColumns = this.tags.map(tag => tag.name);
          }
        })
        getGroups().then(res=>{
          if(res.code === 200){
            this.groups = res.data;
          }
        })
        getAdmin(this.id).then(res=>{
          if(res.code === 200){
            this.form = res.data;
            console.log(this.form);
          }
        })
      },
      
      close() {
        // 初始化表单
        this.initForm();
        _this.$emit("close");
      },
      
      // 初始化表单数据
      initForm() {
        this.form = {
          username: "",
          nickname: "",
          gender: 0,
          email:'',
          avatar:'',
          role:[],
          tags:[],
          group_id:'',
          department_id:''
        };
      },
      
      // 电脑端提交
      submit(form) {
        this.$refs[form].validate(valid => {
          if (valid) {
            updateAdmin(this.id,_this.form).then(res => {
              if (res.code === 200) {
                _this.$message({
                  message: "修改成功",
                  type: "success"
                });
                setTimeout(() => {
                  _this.$emit("success");
                }, 1000);
              }
            })
          } else {
            console.log("error submit!!");
            return false;
          }
        })
      },
      
      // 手机端提交
      onMobileSubmit() {
        this.$refs.mobileForm.validate().then(() => {
          // 验证通过，提交数据
          updateAdmin(this.id, this.form).then(res => {
            if (res.code === 200) {
              Toast({
                message: '修改成功',
                type: 'success',
                duration: 1500
              });
              setTimeout(() => {
                this.$emit("success");
                this.$emit("close");
              }, 1500);
            } else {
              Toast({
                message: res.message || '修改失败',
                type: 'fail',
                duration: 1500
              });
            }
          }).catch(error => {
            Toast({
              message: '网络错误，请稍后重试',
              type: 'fail',
              duration: 1500
            });
          });
        }).catch(errorInfo => {
          // 验证失败
          console.log('表单验证失败：', errorInfo);
        });
      },
      
      // 性别选择确认
      onGenderConfirm(value, index) {
        this.form.gender = index === 0 ? 0 : 1;
        this.showGenderPicker = false;
      },
      
      // 角色选择确认
      onRoleConfirm(values, indexes) {
        this.form.role = indexes.map(index => this.roles[index].role_id);
        this.showRolePicker = false;
      },
      
      // 标签选择确认
      onTagConfirm(values, indexes) {
        this.form.tags = indexes.map(index => this.tags[index].tag_id);
        this.showTagPicker = false;
      }
    }
  };
</script>
<style lang="scss" scoped>
  .form-container {
    width: 100%;
    height: 100%;
  }

  // 电脑端样式
  .avatar-uploader .el-upload {
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }

  .avatar-uploader-icon {
    border: 1px dashed #ccc;
    border-radius: 50%;
    overflow: hidden;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }

  .el-radio-group {
    text-align: left !important;
  }

  // 手机端样式
  .mobile-form-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .mobile-form-content {
    flex: 1;
    overflow-y: auto;
    padding-bottom: 45px;
  }

  .mobile-form-actions {
    display: flex;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
  }

  .mobile-form-actions .van-button {
    flex: 1;
    height: 44px;
    font-size: 16px;
  }
</style>
